import React from "react";
import { Button as ButtonMUI } from "@mui/material";
import classes from "./Button.module.scss";

export default function Button({
    children,
    text,
    className = "",
    size,
    selected = false,
    unselected = false,
    ...props
}) {
    return (
        <ButtonMUI
            {...props}
            className={`${classes.button} ${size ? classes[size] : ""} ${selected ? classes.selected : ""} ${unselected ? classes.unselected : ""} ${className}`}
        >
            {text || children}
        </ButtonMUI>
    );
}